const globalMeta = {
  siteName: `Encontre as Melhores Vagas de Emprego - O Amarelinho`,
  siteUrl: `https://oamarelinho.com.br`,
  siteLogo: `https://static-public.oamarelinho.com.br/amarelinho_fundo_amarelo.png`,
  email: `contato@oamarelinho`,
  description: `O maior jornal de empregos do Brasil também pode ser acessado online. O Amarelinho agora é de graça, acesse e encontre o seu emprego ideal!`,
  ogType: `website`,
};

export default globalMeta;
